module.exports = __webpack_public_path__ + "static/media/mental-threats@3x.5c909d5a.png";